import * as React from 'react';
import { SUGGEST_PROP_DEFAULTS } from '../constants';
import { ISuggestProps } from '../../types';

export function useMaxLinesCssVarable(
  params: { ref: React.RefObject<HTMLElement | null>; maxLines: number | undefined } & Pick<
    ISuggestProps<unknown>,
    'maxHeight' | 'open'
  >,
) {
  React.useEffect(() => {
    params.ref.current?.style.setProperty(
      '--suggest-max-lines',
      (params.maxLines ?? SUGGEST_PROP_DEFAULTS.maxLines)?.toString(),
    );
  }, [params.maxLines, params.ref, params.open]);
}
